import "./Loader.css";

const Loader = ({bigLoader}) => {
    return <div className={bigLoader?"bigLoader":"smallLoader"}></div>
};
export default Loader;
